import { FineService } from "../services";

const extractBuildingId = (params) => {
  if (!params) return undefined;
  if (typeof params === "number") return params;
  if (typeof params === "object") {
    if (typeof params.buildingId === "number") return params.buildingId;
    if (typeof params.buildingId === "object") return params.buildingId?.id;
    if (typeof params.building === "number") return params.building;
    if (typeof params.building === "object") return params.building?.id;
    if (typeof params.id === "number") return params.id;
  }
  return undefined;
};

export const fine = {
  state: () => ({
    fines: [],
    selectedFines: [],
    current: null,
  }),
  mutations: {
    setFines: (state, value) => (state.fines = value || []),
    setSelectedFines: (state, value) => (state.selectedFines = value || []),
    setCurrentFine: (state, value) => (state.current = value || null),
  },
  actions: {
    FINE_FIND_ALL: async ({ commit }, params = {}) => {
      const response = await FineService.findAll(params);
      if (response.ok) {
        commit("setFines", response.data || []);
      } else {
        alert(response.message || "No fue posible obtener las multas");
      }
      return response;
    },
    FINE_FIND_ONE: async ({ commit }, id) => {
      const response = await FineService.findById(id);
      if (response.ok) {
        commit("setCurrentFine", response.data || null);
      } else {
        alert(response.message || "No fue posible obtener la multa");
      }
      return response;
    },
    FINE_CREATE: async ({ dispatch }, payload) => {
      const response = await FineService.create(payload);
      if (response.ok) {
        const buildingId = extractBuildingId(payload?.buildingId ?? payload);
        if (buildingId) {
          await dispatch("FINE_FIND_ALL", { buildingId });
        }
      }
      return response;
    },
    FINE_UPDATE: async ({ dispatch }, { id, ...payload }) => {
      const response = await FineService.update({ id, ...payload });
      if (response.ok) {
        const buildingId = extractBuildingId(payload?.buildingId ?? payload);
        if (buildingId) {
          await dispatch("FINE_FIND_ALL", { buildingId });
        }
      }
      return response;
    },
    FINE_DELETE: async ({ dispatch }, { id, buildingId }) => {
      const response = await FineService.remove(id);
      if (response.ok) {
        const resolvedBuildingId = extractBuildingId(buildingId);
        if (resolvedBuildingId) {
          await dispatch("FINE_FIND_ALL", { buildingId: resolvedBuildingId });
        }
      }
      return response;
    },
    FINE_DOWNLOAD_EXCEL: async (_, payload) => FineService.downloadExcel(payload),
  },
  getters: {
    fineById: (state) => (id) => state.fines.find((fine) => fine.id === id) || null,
  },
};
